export function getLocalHourFromUTC(UTCHour: string): string {
  // 1. Split the UTC time string into hours and minutes
  const [hour, minute] = UTCHour.split(":").map(Number);

  // 2. Create a UTC Date object using today's date and the given time
  const now = new Date(); // Get current date
  const utcDate = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      hour,
      minute
    )
  );

  // 3. Convert to local time using toLocaleTimeString
  return utcDate.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function getUTCHourFromLocal(localHour: string): string {
  // 1. Parse the local time string
  const [hour, minute] = localHour.split(":").map(Number);

  // 2. Create a Date object in local time
  const now = new Date();
  const localDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hour,
    minute
  );

  // 3. Extract the UTC hour and minute
  const utcHour = localDate.getUTCHours().toString().padStart(2, "0");
  const utcMinute = localDate.getUTCMinutes().toString().padStart(2, "0");

  return `${utcHour}:${utcMinute}`;
}
